import React from 'react';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { usePrimaryTier } from '../../../../../../Tier/PrimaryTierContext';
import { Trans } from 'react-i18next';
import { formatPrice } from '../../../../../TierProductCardDumb/utils';
import { useSubscribeButton } from '../../../../../../Button/SubscribeButton/useSubscribeButton';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
const NeedsSubscriptionMiddleContent = ({ deviation , thumbHeight , thumbWidth , className  })=>{
    var _tier_tier;
    const newSubscribeButtons = useFlag('subscribe_btns');
    const tier = usePrimaryTier(deviation);
    const { onClick , href , biData , text  } = useSubscribeButton(tier);
    if (!tier) {
        return null;
    }
    const canShowDescription = thumbWidth && thumbWidth > 250 ? thumbHeight && thumbHeight > 200 : thumbHeight && thumbHeight > 230;
    const canShowCTA = thumbWidth && thumbWidth > 250 ? thumbHeight && thumbHeight > 150 : thumbHeight && thumbHeight > 200;
    const isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
                type: "in-tier",
                size: "large"
            }),
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        icon: /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            type: "in-tier",
            size: newSubscribeButtons ? 'small' : 'large'
        }),
        subtitle: canShowDescription ? /* prettier-ignore */ /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "deviationview.overlay.subscriber.perMonth"
        }, /*#__PURE__*/ React.createElement("span", null, {
            dollarPrice: formatPrice((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.dollarPrice)
        }), "/month") : undefined,
        buttonHref: href,
        buttonTitle: canShowCTA ? text : undefined,
        buttonStyle: newSubscribeButtons ? 'solid' : 'branded',
        buttonIcon: newSubscribeButtons ? TierIcon : undefined,
        onButtonClick: onClick,
        biData: biData,
        className: className
    });
};
NeedsSubscriptionMiddleContent.displayName = 'NeedsSubscriptionMiddleContent';
export default NeedsSubscriptionMiddleContent;
